<template>
    <div class="container" style="padding-right: 0px">
        <b-form-group label-cols="3" :label="$t('general.type')" label-for="input-type">
            <b-form-input id="input-type" class="mayrinput" v-model.lazy="computedSelectedTypenschluessel" @change="changets"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>

    export default {
        name: "TypeInput",
        props: ['typenSchluessel'],
        computed: {
            computedSelectedTypenschluessel: {
                get() {
                    return this.typenSchluessel;
                },
                set(value) {
                    // ignore, function changets is used
                    this.tmpvalue = value;
                }
            }
        },
        methods: {
            changets: function() {
                this.$store.dispatch('updateTypenschluessel', this.tmpvalue);
            }
        }

    }

</script>

<style scoped>

    .mayrinput {
        border-radius: 0px
    }

</style>